export enum SupportEntityType {
  SUPPORT = 'support',
  PUBLIC_SUPPORT = 'publicSupport',
}
